module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"skip":"Jeg husker ikke. Hopp over"},"en":{"skip":"I don\u0027t remember. Skip this"}}')
  delete Component.options._Ctor
}
